import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component/umpire-component';
import {UmpireSurvey} from '../umpire-survey';

export interface UmpireComponentSurvey
  extends UmpireComponent<UmpireComponentTypeEnum.SURVEY> {
  survey: UmpireSurvey;
}
